import { observer } from 'mobx-react';
import ProfilerHeatmap from '../../ProfilerHeatmap/ProfilerHeatmap';

/**
 * ComparableCompaniesHeatmapView - Heatmap view for comparable companies
 *
 * Renders ProfilerHeatmap component with:
 * - Sorted companies as heatmap tiles
 * - Configurable tile size (revenue, employees, etc.)
 * - Configurable color coding (sector, country, etc.)
 * - Grouping functionality
 *
 * This is the view component for the "heatmap" display mode.
 * Parent/orchestrator is responsible for calculating showCagr4Y and searchCategory.
 */
const ComparableCompaniesHeatmapView = observer(function ComparableCompaniesHeatmapView({ sortedCompanies, state, showCagr4Y, showEbitMargin = true, searchCategory }) {
  return (
    <ProfilerHeatmap
      results={sortedCompanies}
      displayDetails={state.onSimilarCompanyDetailsClick}
      searchId={state.comparablesId}
      sizeProperty={state.profilerHeatmapTileSize}
      colorProperty={state.profilerHeatmapColorCoding}
      groupProperty={state.profilerHeatmapGroup}
      setToggleProfilerHeatmapGroupingCallback={state.setToggleProfilerHeatmapGroupingCallback}
      showCagr4Y={showCagr4Y}
      showEbitMargin={showEbitMargin}
      searchCategory={searchCategory}
    />
  );
});

export default ComparableCompaniesHeatmapView;
